import * as AbsintheSocket from "@absinthe/socket";
import {createAbsintheSocketLink} from "@absinthe/socket-apollo-link";
import {Socket as PhoenixSocket} from "phoenix";
import {SOCKET_ENDPOINT} from "../config";

export default createAbsintheSocketLink(AbsintheSocket.create(
  new PhoenixSocket(SOCKET_ENDPOINT, {
    params: () => {
      return {
        token: localStorage.getItem("access_token")
      }
    }
  })
));